var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"component-wrap"},[_c('Favourites')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }